import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals/Globals';
import { isUndefined } from 'util';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class HttpService {
  constructor(
    private http: HttpClient,
    private cookiesService: CookieService,
  ) {}

  pushFileToStorage(
    files: File,
    id: any,
    view: any,
    tag: any,
  ): Observable<HttpEvent<{}>> {
    const formdata: FormData = new FormData();
    formdata.append('file', files);

    const params = new HttpParams()
      .set('file', JSON.stringify(formdata))
      .set('templateId', id)
      .set('viewId', view)
      .set('tag', tag);

    const req = new HttpRequest(
      'POST',
      Globals.SERVER_ADDR + '/cpBuilder/img/create',
      formdata,
      {
        reportProgress: true,
        params: params,
        responseType: 'text',
        headers: this.getHeaders(),
      },
    );

    return this.http.request(req);
  }

  uploadDynamicImage(
    ruleId,
    viewId,
    tag: any,
    file: File,
  ): Observable<HttpEvent<{}>> {
    const formdata: FormData = new FormData();
    formdata.append('file', file);

    const params = new HttpParams()
      .set('file', JSON.stringify(formdata))
      .set('ruleId', ruleId)
      .set('viewId', viewId)
      .set('tag', tag);

    const req = new HttpRequest(
      'POST',
      Globals.SERVER_ADDR + '/cp/dynamicImages/updateImage',
      formdata,
      {
        reportProgress: true,
        params: params,
        responseType: 'text',
        headers: this.getHeaders(),
      },
    );

    return this.http.request(req);
  }

  getFiles(view, tag, id): Observable<any> {
    return this.get(
      Globals.SERVER_ADDR +
        '/cpBuilder/img/find/' +
        `${view}/${tag}` +
        `?templateId=${id}`,
    );
  }

  updateTemplate(requestBody) {
    return this.post(Globals.SERVER_ADDR + '/cpBuilder/update', requestBody);
  }

  getDefaultDashboardParams() {
    return this.get(
      Globals.SERVER_ADDR + '/dashboard/mostRecentDashboardParams',
    );
  }

  getDashboardData(params) {
    return this.post(Globals.SERVER_ADDR + '/dashboard/data', params);
  }

  /**/
  get(url: string) {
    return this.http.get(url, { headers: this.getHeaders() });
  }

  post(url: string, body: any) {
    return this.http.post(url, body, this.getOptions());
  }

  getOptions() {
    return {
      crossdomain: true,
      headers: this.getHeaders(),
    };
  }

  getHeaders() {
    let token = Globals.TOKEN;
    if (isUndefined(token)) {
      token = this.cookiesService.get(Globals.COOKIES_TOKEN);
    }
    let headers = new HttpHeaders();
    headers = headers.set('X-AUTH-TOKEN', token ? token : '');
    headers = headers.set('Cross-Origin', 'true');
    headers = headers.set(
      'CLIENT-ID',
      this.cookiesService.get(Globals.COOKIES_CLIENT_ID),
    );
    return headers;
  }

  getPDFPeriods() {
    return this.get(Globals.SERVER_ADDR + '/reports/pdf/getMonths');
  }

  getPDFLocGroups() {
    return this.post(Globals.SERVER_ADDR + '/org/venueGroups/getTree', {
      withLocations: false,
      getAll: true,
      withNoParent: false,
      excludeId: undefined,
    });
  }

  getVenueGroups() {
    return this.get(Globals.SERVER_ADDR + '/org/venueGroups/getAll');
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/services/http.service.ts